'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _overlay = require('@alicd/next/lib/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _menu = require('@alicd/next/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _input = require('@alicd/next/lib/input');

var _input2 = _interopRequireDefault(_input);

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _form = require('@alicd/next/lib/form');

var _form2 = _interopRequireDefault(_form);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _grid = require('@alicd/next/lib/grid');

var _grid2 = _interopRequireDefault(_grid);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _index2 = require('../local/index.js');

var _index3 = _interopRequireDefault(_index2);

var _InterDialog = require('../InterDialog');

var _InterDialog2 = _interopRequireDefault(_InterDialog);

var _FilterItem = require('./FilterItem');

var _FilterItem2 = _interopRequireDefault(_FilterItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;

var Filter = function (_React$Component) {
  (0, _inherits3.default)(Filter, _React$Component);

  function Filter(props) {
    (0, _classCallCheck3.default)(this, Filter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Filter.__proto__ || (0, _getPrototypeOf2.default)(Filter)).call(this, props));

    _this.state = {
      searchCondition: _this.props.searchCondition,
      overlayVisible: false,
      _defaultSelectKey: _this.props.defaultSelectKey
    };
    _this.reset = _this.reset.bind(_this);
    _this.clear = _this.clear.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Filter, [{
    key: 'reset',
    value: function reset() {
      var field = this.props.field;
      if (this.props.onReset) {
        this.props.onReset(field);
      }
      if (field) {
        field.reset();
        var values = field.getValues();
        var setErrors = field.setErrors;
        for (var name in values) {
          if (values.hasOwnProperty(name)) {
            var obj = {};
            obj[name] = undefined;
            setErrors(obj);
          }
        }
      }
    }
  }, {
    key: 'clear',
    value: function clear() {
      var field = this.props.field;

      if (this.props.onClear) {
        this.props.onClear(field);
      }
      if (field) {
        var setErrors = field.setErrors,
            setValue = field.setValue;

        var values = field.getValues();
        for (var name in values) {
          if (values.hasOwnProperty(name)) {
            var obj = {};
            obj[name] = undefined;
            setErrors(obj);
            setValue(name, '');
          }
        }
      }
    }
  }, {
    key: 'clickToChangeCondition',
    value: function clickToChangeCondition(key) {
      if (this.props.onChangeCondition) {
        this.props.onChangeCondition(key);
      } else {
        this.setState({
          _defaultSelectKey: key
        });
      }
    }
  }, {
    key: 'getSelectContent',
    value: function getSelectContent() {
      var _index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number(this.props.selectKey);

      if (_index) {
        return this.props.children.filter(function (item) {
          return item.key === _index;
        })[0];
      } else {
        return this.props.children[0];
      }
    }
  }, {
    key: 'getRightConditionContent',
    value: function getRightConditionContent() {
      var _index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.selectKey;

      var children = this.getSelectContent(_index);

      if (children) {
        var field = this.props.field;
        if (children.type === _FilterItem2.default) {
          return _react2.default.createElement(
            _form2.default,
            { field: field, className: 'cn-inter-filter-form', labelAlign: 'left', labelTextAlign: 'right' },
            _react2.default.createElement(
              'div',
              { className: 'cn-task-form-content' },
              children
            )
          );
        } else {
          console.error('the TaskFilter numerator must be TaskFilter.Item');
        }
      } else {
        return null;
      }
    }
  }, {
    key: 'changeCondition',
    value: function changeCondition(data) {
      this.setState({
        overlayVisible: data.length > 0,
        searchCondition: data
      });
    }
  }, {
    key: 'focusSearchHandler',
    value: function focusSearchHandler() {
      this.setState({
        overlayVisible: true
      });
    }
  }, {
    key: 'changeConditionMenu',
    value: function changeConditionMenu(key) {
      this.setState({
        overlayVisible: false
      });
      if (this.props.onChangeCondition) {
        this.props.onChangeCondition(key);
      } else {
        this.setState({
          _defaultSelectKey: key
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _searchCondition = this.state.searchCondition;
      var _leftMenu = [];

      var _props = this.props,
          children = _props.children,
          onCancel = _props.onCancel,
          onOk = _props.onOk,
          locale = _props.locale,
          loading = _props.loading,
          searchPlaceholder = _props.searchPlaceholder,
          onChangeCondition = _props.onChangeCondition,
          onReset = _props.onReset,
          onClear = _props.onClear,
          field = _props.field,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onCancel', 'onOk', 'locale', 'loading', 'searchPlaceholder', 'onChangeCondition', 'onReset', 'onClear', 'field']);
      var _index = other.selectKey;


      if (_index === undefined) {
        _index = this.state._defaultSelectKey || children[0].key;
      }

      if (_searchCondition) {
        children.map(function (item) {
          if (item.type === _FilterItem2.default) {
            if (item.props.title.toLowerCase().indexOf(_searchCondition.toLowerCase()) > -1 || item.key.toLowerCase().indexOf(_searchCondition.toLowerCase()) > -1) {
              _leftMenu.push({
                visible: item.props.visible,
                title: item.props.title,
                key: item.key,
                valuePlaceholder: item.props.valuePlaceholder
              });
            } else {
              return null;
            }
          }
        });
      } else {
        children.map(function (item) {
          if (item.type === _FilterItem2.default) {
            _leftMenu.push({
              visible: item.props.visible,
              title: item.props.title,
              key: item.key,
              valuePlaceholder: item.props.valuePlaceholder
            });
          }
        });
      }
      var rightConditionContent = this.getRightConditionContent(_index);
      return _react2.default.createElement(
        _InterDialog2.default,
        (0, _extends3.default)({ setting: '', footer: _react2.default.createElement(
            'div',
            { className: 'Modal-footer' },
            _react2.default.createElement(
              'button',
              { className: 'button-dark', onClick: onOk },
              loading ? _react2.default.createElement(_icon2.default, { style: { marginRight: 8 }, type: 'loading' }) : null,
              locale.ok
            ),
            _react2.default.createElement(
              'button',
              { className: 'button-secondary', onClick: this.reset },
              locale.reset
            ),
            _react2.default.createElement(
              'button',
              { className: 'button-danger', onClick: this.clear },
              locale.clear
            ),
            _react2.default.createElement(
              'button',
              { className: 'button-light', onClick: onCancel },
              locale.cancel
            )
          ) }, other, { loading: loading, onOk: onOk, onCancel: onCancel }),
        _react2.default.createElement(
          Row,
          { type: 'no-padding', className: 'cn-inter-filter' },
          _react2.default.createElement(
            Col,
            { span: 12, className: 'filter-left' },
            _react2.default.createElement(
              'div',
              { className: 'cn-inter-filter-search addon-after-search' },
              _react2.default.createElement(_input2.default, {
                ref: '_target',
                value: this.state.searchCondition,
                className: 'cn-inter-search-input',
                placeholder: searchPlaceholder || locale.searchPlaceholder,
                onChange: this.changeCondition.bind(this),
                onFocus: this.focusSearchHandler.bind(this),
                addonAfter: _react2.default.createElement(_icon2.default, {
                  size: 'small',
                  onClick: function onClick() {
                    _this2.props.onSearch.call(_this2, _this2.state.searchCondition);
                  },
                  type: 'search' })
              }),
              _react2.default.createElement(
                _overlay2.default,
                { visible: this.state.overlayVisible, target: function target() {
                    return _this2.refs._target;
                  } },
                _react2.default.createElement(
                  _menu2.default,
                  { style: { width: '338px' }, onClick: this.changeConditionMenu.bind(this) },
                  _leftMenu.map(function (item) {
                    if (item.visible !== false) {
                      return _react2.default.createElement(
                        _menu2.default.Item,
                        { key: item.key },
                        item.title
                      );
                    } else {
                      return null;
                    }
                  })
                )
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: 'filter-condition-list' },
              children.map(function (item, index) {
                if (item.props.visible === false) {
                  return false;
                }
                return _react2.default.createElement(
                  'li',
                  {
                    className: _index === item.key ? 'selected filter-condition-list-item' : 'filter-condition-list-item',
                    key: index,
                    onClick: function onClick(e) {
                      _this2.clickToChangeCondition.call(_this2, item.key);
                    }
                  },
                  _react2.default.createElement(
                    Row,
                    { type: 'no-padding' },
                    _react2.default.createElement(
                      Col,
                      { span: '11', title: item.props.title, className: 'filter-condition-list-title' },
                      item.props.title
                    ),
                    _react2.default.createElement(
                      Col,
                      { span: '11', title: item.props.valuePlaceholder, className: 'align-right filter-condition-list-selected' },
                      item.props.valuePlaceholder
                    ),
                    _react2.default.createElement(Col, { span: '2', className: 'align-center filter-condition-list-selected' })
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            Col,
            { span: 12, className: 'filter-right' },
            rightConditionContent
          )
        )
      );
    }
  }]);
  return Filter;
}(_react2.default.Component);

Filter.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  align: _propTypes2.default.string,
  selectKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  defaultSelectKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  searchPlaceholder: _propTypes2.default.string,
  searchCondition: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onChangeCondition: _propTypes2.default.func,
  onSearch: _propTypes2.default.func
};
Filter.defaultProps = {
  width: 872,
  height: 640,
  searchPlaceholder: null,
  searchCondition: '',
  onOk: function onOk() {},
  onCancel: function onCancel() {},
  onSearch: function onSearch() {}
};


var LocaleFilter = (0, _localeProvider2.default)(Filter);

LocaleFilter.Item = _FilterItem2.default;

LocaleFilter.LOCALE = _index3.default;

exports.default = LocaleFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-inter-dialog@0.0.46@@alicd/crui-inter-dialog/lib/Filter/Filter.js
// module id = 645
// module chunks = 0